export const THEME_PRESETS = {
  dark_teal: {
    name: "Dark Teal",
    from: "#0f172a",
    via: "#1e293b",
    to: "#0f766e",
    accent: "#14b8a6",
    glow1: "#14b8a6",
    glow2: "#6366f1",
    glow3: "#f59e0b",
  },
  sunset: {
    name: "Sunset",
    from: "#1a1a2e",
    via: "#16213e",
    to: "#7f1d1d",
    accent: "#f59e0b",
    glow1: "#e94560",
    glow2: "#f59e0b",
    glow3: "#ec4899",
  },
  ocean: {
    name: "Ocean",
    from: "#0a192f",
    via: "#112240",
    to: "#164e63",
    accent: "#38bdf8",
    glow1: "#0ea5e9",
    glow2: "#06b6d4",
    glow3: "#818cf8",
  },
  purple_haze: {
    name: "Purple Haze",
    from: "#1a1033",
    via: "#2d1b69",
    to: "#581c87",
    accent: "#a78bfa",
    glow1: "#7c3aed",
    glow2: "#ec4899",
    glow3: "#6366f1",
  },
  midnight: {
    name: "Midnight",
    from: "#09090b",
    via: "#18181b",
    to: "#1c1917",
    accent: "#e4e4e7",
    glow1: "#525252",
    glow2: "#404040",
    glow3: "#292524",
  },
  forest: {
    name: "Forest",
    from: "#052e16",
    via: "#14532d",
    to: "#1a2e05",
    accent: "#4ade80",
    glow1: "#22c55e",
    glow2: "#059669",
    glow3: "#84cc16",
  },
};

export function getThemeStyles(preset, customColors) {
  if (preset === "custom" && customColors) {
    return {
      background: `linear-gradient(160deg, ${customColors.from || "#0f172a"} 0%, ${customColors.via || "#1e293b"} 40%, ${customColors.to || "#0f766e"} 100%)`,
      accent: customColors.accent || "#14b8a6",
      glow1: customColors.from || "#14b8a6",
      glow2: customColors.to || "#6366f1",
      glow3: customColors.accent || "#f59e0b",
    };
  }
  const theme = THEME_PRESETS[preset] || THEME_PRESETS.dark_teal;
  return {
    background: `linear-gradient(160deg, ${theme.from} 0%, ${theme.via} 40%, ${theme.to} 100%)`,
    accent: theme.accent,
    glow1: theme.glow1,
    glow2: theme.glow2,
    glow3: theme.glow3,
  };
}
